<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
<!--                  <a-form-model-item prop="huodongId" >
                        <span slot="label" ><a-tooltip>{{$t('活动关联的商品.活动id')}}<template slot="title">{{$t('活动关联的商品.活动id')}}</template></a-tooltip> </span>
                        <a-input v-model="form.huodongId"  :placeholder="$t('通用.输入.请输入')+'活动id'" >
                          <locale-field-button
                              slot="suffix"
                              class="ant-input-suffix-button"
                              v-model="form.localeFieldMap['huodongId']"
                              input-type="input"
                              table-name="zb_huodong_goods"
                              table-field="huodongId"
                              :field-value="form.huodongId"/>
                        </a-input>
                  </a-form-model-item>-->
                  <a-form-model-item prop="name" >
                        <span slot="label" ><a-tooltip>{{$t('活动关联的商品.商品名称')}}<template slot="title">{{$t('活动关联的商品.商品名称')}}</template></a-tooltip> </span>
                        <a-input v-model="form.name" :maxLength="50" :placeholder="$t('通用.输入.请输入')+'商品名称'" >
                          <locale-field-button
                              slot="suffix"
                              class="ant-input-suffix-button"
                              v-model="form.localeFieldMap['name']"
                              input-type="input"
                              table-name="zb_huodong_goods"
                              table-field="name"
                              :field-value="form.name"/>
                        </a-input>
                  </a-form-model-item>
                  <a-form-model-item prop="picture" >
                        <span slot="label" ><a-tooltip>{{$t('活动关联的商品.活动商品图片')}}<template slot="title">{{$t('活动关联的商品.活动商品图片')}}</template></a-tooltip> </span>
                        <a-upload
                          name="picture"
                          listType="picture-card"
                          :multiple="false"
                          :show-upload-list="false"
                          :preview="handlePreview"
                          :before-upload="beforeOssUpload"
                          :customRequest="pictureImgUpload">
                          <img
                            v-if="form.picture"
                            :src="form.picture"
                            alt="picture"
                            style="height: 102px; width: 102px;"/>
                          <div v-else>
                            <a-icon :type="loading ? 'loading' : 'plus'"/>
                            <div class="ant-upload-text">{{ $t('通用.按钮.上传') }}</div>
                          </div>
                        </a-upload>
                  </a-form-model-item>
<!--                  <a-form-model-item prop="score" >-->
<!--                        <span slot="label" ><a-tooltip>{{$t('活动关联的商品.阶梯积分')}}<template slot="title">{{$t('活动关联的商品.阶梯积分')}}</template></a-tooltip> </span>-->
<!--                        <a-input-number v-model="form.score"  :placeholder="$t('通用.输入.请输入')+'阶梯积分'" >-->
<!--                        </a-input-number>-->
<!--                  </a-form-model-item>-->
<!--                  <a-form-model-item prop="piaoNum" >-->
<!--                        <span slot="label" ><a-tooltip>{{$t('活动关联的商品.投票数量')}}<template slot="title">{{$t('活动关联的商品.投票数量')}}</template></a-tooltip> </span>-->
<!--                        <a-input-number  v-model="form.piaoNum"  disabled>-->
<!--                        </a-input-number>-->
<!--                  </a-form-model-item>-->
                <a-form-model-item prop="sort" >
                  <span slot="label" ><a-tooltip>{{$t('活动关联的商品.排序')}}<template slot="title">{{$t('活动关联的商品.排序')}}</template></a-tooltip> </span>
                  <a-input-number v-model="form.sort" :placeholder="$t('通用.输入.请输入')" allow-clear />
                </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
  import { getHuodongGoods, addHuodongGoods, updateHuodongGoods } from '@/api/huodong/huodongGoods'
  import {mapGetters} from 'vuex'
  import CustomDictTag from "@/components/DictCustomTag";
  import {generateFilePath, uploadObject, uploadOss} from "@/api/tool/oss";
  import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";


  export default {
    name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
      LocaleFieldButton,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
                          id: null,
                          huodongId: null,
                          name: null,
                          picture: null,
                          score: null,
                          sort: null,
                          piaoNum: null,
        localeFieldMap:{},
      },
      // 1增加,2修改
      formType: 1,
      huodongId:0,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
                          id: null,
                          huodongId: null,
                          name: null,
                          picture: null,
                          score: null,
                          sort: null,
                          piaoNum: null,
        localeFieldMap:{},
      }

    },
    /** 新增按钮操作 */
    handleAdd (huodongId) {
      this.huodongId=huodongId
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids,huodongId) {
      this.huodongId=huodongId
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getHuodongGoods({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    // oss 上传开始
    async handlePreview(file) {
      let suffix = file.name.substring(file.name.lastIndexOf('.'));
      if (suffix === '.mp4') {
        this.handleVideoPreview(file);
      } else {
        this.handleImagePreview(file);
      }
    },
    // 上传之前校验
    beforeOssUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 20
      // if (!isJPG) {
      //     this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 20MB!')
      }
      return isLt2M
    },
    // 上传覆盖默认的上传行为
    pictureImgUpload(file, index) {
      const _this = this
      // 获取文件对象
      const uploadFile = file.file
      // 文件夹目录
      const prefix = 'banner'
      const url = uploadOss(uploadFile.name, prefix)
      _this.$nextTick(() => {
        uploadObject(url, uploadFile).then(res => {
          _this.$set(_this.form, 'picture', res)
          _this.$message.success(this.$t('通用.文本.上传成功'),)
        })
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.form.huodongId=this.huodongId
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateHuodongGoods(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addHuodongGoods(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
  }
</script>
